// extracted by mini-css-extract-plugin
export default {"root":"IconProfileSetup_root__0i5Wk"};